import React from "react";
import CreateInvite from "../template/UserManagement";

export default () => <CreateInvite />;
